import { ApiBaseUrl } from "../http";
import { useAppSelector } from "../../redux/hooks";

/**
 * Hook qui fournit une fonction handleExport pour telecharger un fichier XLS
 * depuis un endpoint backend d'export. Suit le meme pattern que ListeDossiers
 * et ListeTransaction (fetch avec Bearer token -> blob -> download).
 */
export function useExportXls(endpoint: string, fileName: string) {
	const { token } = useAppSelector((s) => s?.user);

	const handleExport = () => {
		fetch(`${ApiBaseUrl}/api/${endpoint}/`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => response.blob())
			.then((blob) => {
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", fileName);
				document.body.appendChild(link);
				link.click();
				link.remove();
			});
	};

	return handleExport;
}
